import React from 'react';
import { NiceFormGroup, QuestionWrapper } from './Components.styles';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Waves/Waves.styles';
import { ApIcon, colors } from '@alixpartners/ui-components';

const NumberInput = ({
	questionNo,
	label,
	placeholder,
	handleChange,
	name,
	value,
	required,
	instructions,
	isGlobalRevenue,
	handleDropdownChange,
	selectedValue,
	options,
	dropDownId,
}) => {
	return (
		<NiceFormGroup>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<QuestionWrapper>
					<div className="questionNo">{questionNo}.&nbsp;</div>
					<label>{label}</label>
					{instructions && (
						<Tooltip
							position="bottom"
							animation="fade"
							arrow
							html={<TooltipContent>{instructions}</TooltipContent>}
							trigger="mouseenter"
							style={{ marginBottom: '4px', marginLeft: '5px' }}
						>
							<ApIcon
								iconName="info"
								iconSize="22px"
								outlined={true}
								iconColor={colors.green300}
							/>
						</Tooltip>
					)}
				</QuestionWrapper>
			</div>
			<input
				style={{ width: '200px' }}
				type="text"
				placeholder={placeholder}
				onChange={e => {
					e.target.isNumber = true;
					handleChange(e);
				}}
				name={name}
				value={value}
				required={required}
			/>
			{isGlobalRevenue && (
				<select
					style={{ width: '200px', marginLeft: '20px' }}
					id={dropDownId}
					value={selectedValue}
					onChange={e => handleDropdownChange(e)}
					required
				>
					<option hidden> -- select an option -- </option>

					{options.map(({ key, label, value }) => {
						return (
							<option key={key} value={value}>
								{label}
							</option>
						);
					})}
				</select>
			)}
		</NiceFormGroup>
	);
};

export default NumberInput;
